import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { CropperSettings, ImageCropperComponent } from 'ngx-img-cropper';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'upload-photo-modal',
	template: ''
})
export class UploadPhotoModalComponent implements AfterViewInit, OnDestroy {
	@ViewChild('cropper', undefined)
	cropper: ImageCropperComponent;
	photo: any;
	button_disable: boolean;
	cropperSettings: CropperSettings;
	data: any;
	clientId: number;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public fileUploadDataService: FileUploadDataProvider,
		public messageService: MessageService
	) {
		this.cropperSettings = new CropperSettings();
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.canvasWidth = 300;
		this.cropperSettings.rounded = true;
		this.cropperSettings.showCenterMarker = false;
		this.cropperSettings.markerSizeMultiplier = 0.5;
		this.cropperSettings.centerTouchRadius = 80;
		this.cropperSettings.preserveSize = true;
		this.cropperSettings.croppedWidth = 80;
		this.cropperSettings.croppedHeight = 80;
		this.data = {};
	}
	ngAfterViewInit() {
		this.fileUploadDataService.uploadedPhoto$
			.takeUntil(this.unsubscribe)
			.subscribe(data => {
				if (data !== null && typeof data !== 'undefined') {
					const { img, clientId } = data;
					this.cropper.setImage(img);
					this.clientId = clientId;
				}
			});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	hideModal(): void {}

	savePhoto(): void {
		this.button_disable = true;
		if (this.clientId !== null) {
			this.fileUploadDataService
				.uploadClientPhoto(this.data.image, this.clientId)
				.finally(() => (this.button_disable = false))
				.subscribe(
					() => {
						this.fileUploadDataService.emitNewPhoto(this.clientId);
						this.messageService.showToaster('s_3', 'profile');
						this.hideModal();
					},
					err => this.messageService.showDefaultErrorMessage(err)
				);
		} else if (this.clientId === null) {
			this.fileUploadDataService
				.uploadUserPhoto(this.data.image)
				.finally(() => (this.button_disable = false))
				.subscribe(
					() => {
						this.fileUploadDataService.emitNewPhoto(this.clientId);
						this.messageService.showToaster('s_3', 'profile');
						this.hideModal();
					},
					err => this.messageService.showDefaultErrorMessage(err)
				);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/base/client/modals/upload-photo-modal/upload-photo-modal.ts